import React from 'react';

import { FieldTableHeader } from 'components/_basic/Form/FieldTable2/components/FieldTableHeader';
import { FieldTableTotalRow } from 'components/_basic/Form/FieldTable2/components/FieldTableTotalRow';
import { FieldTableContainer } from 'components/_basic/Form/FieldTableContainer';

import { concatWithDot } from 'helpers/string';

import { FieldTableRow } from './components/FieldTableRow';
import { IFundingDirectionsFormTableProps } from './types';
import { fundingDirectionsPrefix } from '../../../../utils/form';
import { SUB_ROWS_NAMES_ARRAY } from '../../utils/form';

import styles from './FundingDirectionsFormTable.module.scss';

export const FundingDirectionsFormTable: React.FC<IFundingDirectionsFormTableProps> = ({
  name,
  headerName = '',
  totalName = '',
  columnsNames,
  rows,
  watchRowTitleName,
  firstColumnWidth = 250,
  disabled = false,
  showSumRow = false,
  totalRowTitle = '',
}) => {
  return (
    <FieldTableContainer>
      <FieldTableHeader
        name={headerName}
        disabled={disabled}
        columnsNames={columnsNames}
        firstColumnWidth={firstColumnWidth}
        editableColumn={true}
        firstColumnClass={styles.sticky}
        titleColumnGap={1}
      />

      {rows.map((rowItem, index) => (
        <FieldTableRow
          key={rowItem.id}
          name={name}
          rowIndex={index}
          columnsNames={columnsNames}
          watchRowTitleName={watchRowTitleName}
          firstColumnWidth={firstColumnWidth}
          disabled={disabled}
          subRowName={concatWithDot(fundingDirectionsPrefix, SUB_ROWS_NAMES_ARRAY[index])}
        />
      ))}

      {showSumRow && totalName && (
        <FieldTableTotalRow
          totalName={totalName}
          columns={columnsNames}
          disabled={disabled}
          firstColumnWidth={firstColumnWidth}
          totalRowTitle={totalRowTitle}
          titleColumnGap={1}
          titleStyles={styles.totalRowTitleStyles}
        />
      )}
    </FieldTableContainer>
  );
};
